<template>
  <div>
    <qx-card title="客户" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.relId"
      busiCode="400000"
      :inFast="Boolean(id)"
      :handleRefresh="handleRefresh"
    />
  </div>
</template>

<script>
import {
  servicerDetail, // 获取详情
} from 'api/service';
import {
  approveItemInfo,
} from 'api';
import ApproveBox from 'components/approveBox';
export default {
  components: {
    ApproveBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    handleRefresh: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      loading: false,
      serviceUserId: '',
      detailData: {
        base: {
          label: '基础信息',
          tableData: {
            title: [
              {
                prop: 'loginAcct',
                label: '手机账号',
              },
              {
                prop: 'serviceName',
                label: '服务商名',
              },
              {
                prop: 'serviceTypeName',
                label: '账号类型',
              },
              {
                prop: 'companyAddress',
                label: '公司地址',
              },
              {
                prop: 'realAuthTypeName',
                label: '实名认证方式',
              },
              {
                prop: 'linkman',
                label: '负责人',
              },
              {
                prop: 'identification',
                label: '身份证号',
              },
              {
                prop: 'idCardFaceUrl',
                label: '身份证头像面',
                type: 'img',
              },
              {
                prop: 'idenPictureBackUrl',
                label: '身份证国徽面',
                type: 'img',
              },
              {
                prop: 'creditCode',
                label: '统一社会信用代码',
              },
              {
                prop: 'creditPicUrl',
                label: '营业执照',
                type: 'img',
              },
              {
                prop: 'stateName',
                label: '账号状态',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        settlement: {
          label: '账期信息',
          tableData: {
            title: [
              {
                prop: 'balanceTypeName',
                label: '结算方式',
              },
              {
                prop: 'recive',
                label: '付款期限',
              },
              {
                prop: 'quotaAmtStr',
                label: '授信金额',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  methods: {
    async getData () {
      if (this.$route.path !== '/manage/service/merchant/manage/detail' && !this.id) {
        return;
      }
      this.loading = true;
      const detailRes = await servicerDetail({
        serviceUserId: this.serviceUserId || this.$route.query.id,
        isEdit: 2,
      });
      this.loading = false;
      if (!detailRes.failed) {
        switch (String(detailRes.serviceData.balanceType)) { // 结算方式
          case '1': // 账期
            detailRes.serviceData.recive = detailRes.serviceData.paymentDays;
            break;
          case '2': // 月结
            detailRes.serviceData.recive = `${detailRes.serviceData.paymentMonth}个月后${detailRes.serviceData.paymentDays}号`;
            break;
          default:
            break;
        }
        if (String(detailRes.serviceData.realAuthType) === '1') { // 个人
          detailRes.serviceData.idCardFaceUrl = detailRes.serviceData.idenPictureFrontUrl;
          // detailRes.serviceData.
        } else { // 企业
          detailRes.serviceData.creditCode = detailRes.serviceData.creditCode || detailRes.serviceData.identification;
          detailRes.serviceData.creditPicUrl = detailRes.serviceData.idenPictureFrontUrl;
        }
        this.detailData.base.tableData.data = detailRes.serviceData;
        this.detailData.settlement.tableData.data = detailRes.serviceData;
        if (this.$route.query.type || this.id) {
          switch (String(detailRes.serviceDataVer.balanceType)) { // 结算方式
            case '1': // 账期
              detailRes.serviceDataVer.recive = detailRes.serviceDataVer.paymentDays;
              break;
            case '2': // 月结
              detailRes.serviceDataVer.recive = `${detailRes.serviceDataVer.paymentMonth}个月后${detailRes.serviceData.paymentDays}号`;
              break;
            default:
              break;
          }
          if (String(detailRes.serviceDataVer.realAuthType) === '1') { // 个人
            detailRes.serviceDataVer.idCardFaceUrl = detailRes.serviceDataVer.idenPictureFrontUrl;
          } else { // 企业
            detailRes.serviceDataVer.creditCode = detailRes.serviceDataVer.creditCode || detailRes.serviceDataVer.identification;
            detailRes.serviceDataVer.creditPicUrl = detailRes.serviceDataVer.idenPictureFrontUrl;
          }
          this.detailData.base.tableData.approveData = detailRes.serviceDataVer;
          this.detailData.settlement.tableData.approveData = detailRes.serviceDataVer;
        }
      }
    },
  },
  async created () {
    if (this.id) {
      const res = await approveItemInfo({
        busiId: this.id,
        busiCode: 400000,
      });
      this.serviceUserId = res.serviceUserId;
    }
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import "styles/config.scss";
.orderStatusBox{
  overflow: auto;
}
.orderInfoBox{
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title{
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,.time{
    color: #666;
    line-height: 16px;
  }
  .desc{
    padding-bottom: 12px;
  }
}
.box{
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel{
  background: $grey;
}
.itemLabel,.itemText{
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
